import { AdminSidebarLinkItems } from '@grcs/views/shared/components/navigation/SidebarLinkItems/AdminSidebarLinkItems';
import { SidebarWithHeader } from '@grcs/views/shared/components/navigation/SidebarWithHeader';
import { AdminProtectedRoute } from '../ProtectedRoute/AdminProtectedRoute';

export const AdminSidebarWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <AdminProtectedRoute>
      <SidebarWithHeader sidebarItems={AdminSidebarLinkItems}>
        {children}
      </SidebarWithHeader>
    </AdminProtectedRoute>
  );
};
